/**
 * Pre-compiled es messages for DraggableList
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  emptyMessage: `Soltar artículos aquí`,
  removeButtonLabel: `Eliminar artículo`,
};
